module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal06.f78d8979.png";